import { requestApi } from "../funcitons";

export const CommandsQueries = {
    getAll: async (project_id) => {
        const res = await requestApi(`commands/project/${project_id}`, 'GET');
        return res.data;
    },
    updateStatus: async (command_id, status) => {
        const res = await requestApi(`commands/${command_id}/status`, 'PUT', { status: status });
        return res.data;
    }
}